import { merge } from "react-merge";
import { useMediaQuery } from "react-responsive";
import ContentLoader from "react-content-loader";
import { Color } from "../../enums/Color";

const loaderStyle = {
    mobile: {
        container: {
            width: "90.33vw",
            height: "111.59vw"
        }
    },
    desktop: {
        container: {
            width: "43vw",
            height: "46.87vw"
        }
    }
};

export const ReplyMailLoader : React.FC = () => {
    const isMobile = useMediaQuery ({ query: "(max-width: 786px)"});
    var styles = loaderStyle.mobile;

    if(!isMobile) {
        let extendedStyle = merge(loaderStyle.mobile, loaderStyle.desktop);
        styles = extendedStyle;
    }

    return (
       <div style={styles.container}>
            <ContentLoader
                speed={1}
                backgroundColor={Color.LoaderBackground}
                foregroundColor={Color.LoaderForeground}
                width= {styles.container.width}
                height= {styles.container.height}
            >
                {isMobile ? <>
                    <rect x="10%" y="10%" rx="0" ry="0" width="100%" height="7.90%" />
                    <rect x="10%" y="20.55%" rx="0" ry="0" width="100%" height="60%" />
                    <rect x="10%" y="88.42%" rx="0" ry="0" width="100%" height="10.98%" />
                    
                </> 
                : <>
                    <rect x="0%" y="8%" rx="0" ry="0" width="50%" height="6.41%" />
                    <rect x="70%" y="8%" rx="0" ry="0" width="30%" height="6.41%" />
                    <rect x="0%" y="18%" rx="0" ry="0" width="100%" height="50.98%" />
                    <rect x="0" y="19.75%" rx="0" ry="0" width="100%" height="11.15%" />
                    <rect x="0" y="72%" rx="0" ry="0" width="100%" height="8.41%" /> 
                    <rect x="0" y="86%" rx="0" ry="0" width="30%" height="6.41%" />
                    <rect x="70%" y="86%" rx="0" ry="0" width="30%" height="6.41%" />   
                </>} 
            </ContentLoader>
       </div>
    )
}